import React from 'react';
import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps,
} from '@mui/material';
import { Typography } from '../typography';

export function FormControlLabel(props: FormControlLabelProps) {
  const { label, ...rest } = props;

  let styledLabel = label;
  if (typeof label === 'string') {
    styledLabel = <Typography variant="body2">{label}</Typography>;
  }

  return <MuiFormControlLabel {...rest} label={styledLabel} />;
}
